import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { KIcon, KCheckbox } from "@kyburz/kdesign-system";
import useSetState from "../hooks/useSetState";
import { DropDownType } from "../interfaces/DropDownInterface";
import { UserInterface } from "../interfaces/UserInterface";

interface Props {
  menuItems: DropDownType[];
  icon?: string;
  setSelectedUsers: (value: UserInterface, checkbox: string) => void;
  currentItem: any;
}

const SelectDropDown = ({
  icon = "more-vertical",
  menuItems,
  setSelectedUsers,
  currentItem,
}: Props) => {
  const [{ anchorEl }, setState] = useSetState({
    anchorEl: null,
  });

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    const target = event?.currentTarget;
    setState({ anchorEl: target });
  };

  const handleClose = (action): void => {
    setState({ anchorEl: null });
    if (action && {}.toString.call(action) === "[object Function]") {
      action();
    }
  };

  const handleCheck = (name: string): void => {
    setSelectedUsers(currentItem, name);
  };

  return (
    <div>
      <KIcon icon={icon} onClick={handleClick} />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map((x) => (
          <MenuItem key={x.title}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <KCheckbox
                name={x.title}
                handleChange={() => handleCheck(x.name)}
                checked={currentItem[x.name]}
                style={{ margin: "8px 0px 8px 0px" }}
              />
              <div style={{ marginLeft: 16 }}>{x.title}</div>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectDropDown;
